import React, {MouseEvent} from "react";
import {observer} from "mobx-react-lite";
import {useAppState} from "@stores/AppStateContext";

import {CalendarDay, CalendarSelectInput} from "./CalendarSelectInput";
import {MODALS} from "../../../screens/modals/modal-names";

import "./CalendarSelect.css";

export interface YearDaysSelectProps {
    selectedDates: CalendarDay[];
    onChange: (dates: CalendarDay[]) => void;
    placeholder: string;
    withBackground?: boolean;
    className?: string;
}

export const YearDaysSelect = observer((
    {
        selectedDates,
        onChange,
        placeholder,
        withBackground,
        className,
    }: YearDaysSelectProps) => {
    const appState = useAppState();
    const isOpen = appState.topModal === MODALS.YEAR_CALENDAR;

    const openModal = () => {
        appState.setModal({name: MODALS.YEAR_CALENDAR, params:{
            getSelectedDates: () => selectedDates,
            onConfirm: async (values: CalendarDay[]) => {
                onChange(values);
            },
        }});
    };
    const _onClick = (event: MouseEvent) => {
        event.stopPropagation();
        if (isOpen) {
            appState.setModal(null);
        } else {
            openModal();
        }
    };

    const label = selectedDates.length
        ? selectedDates.map(({day, month}) => `${day}/${month + 1}`).join(', ')
        : placeholder;

    return (
        <CalendarSelectInput
            className={className}
            onClick={_onClick}
            label={label}
            withBackground={withBackground}
            isPlaceholder={label === placeholder}
            isOpen={isOpen}
        />
    );
});
